/* eslint-disable camelcase */
/* global AMap, AMapUI */

import { loadAMap } from '@/modules/transport/otp/utils/mapLoader';

const warningPointContent = (text) => {
    return `<div class="map-marker-red"><span>${text}</span></div>`;
};

const sentGoodsPointContent = (text) => {
    return `<div class="map-marker-green"><span>${text}</span></div>`;
};

const receiverGoodsPointContent = (text) => {
    return `<div class="map-marker-orange"><span>${text}</span></div>`;
};

let markersMap = new Map();

let infoWindowExample = null;

let timer = null;

const bd_decrypt = (bd_lng, bd_lat) => {
    var X_PI = (Math.PI * 3000.0) / 180.0;
    var x = bd_lng - 0.0065;
    var y = bd_lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
    var gg_lng = z * Math.cos(theta);
    var gg_lat = z * Math.sin(theta);
    return { lng: gg_lng, lat: gg_lat };
};

// eslint-disable-next-line no-magic-numbers
const gd = bd_decrypt(105.216596, 32.013121);
const initialCenter = [gd.lng, gd.lat];

// 见: https://lbs.amap.com/api/amap-ui/reference-amap-ui/mass-data/pathsimplifier/

const EMPTY_ROUTE_DATA = [
    {
        name: '物流轨迹',
        path: []
    }
];

// eslint-disable-next-line max-lines-per-function
export const setupMap = async (mapId, controller) => {
    await loadAMap();
    // eslint-disable-next-line max-lines-per-function
    AMapUI.load(['ui/misc/PathSimplifier', 'ui/overlay/SimpleMarker'], (PathSimplifier) => {
        if (!PathSimplifier.supportCanvas) {
            alert('当前环境不支持 Canvas！');
            return;
        }

        const map = new AMap.Map(mapId, {
            zoom: 4, // 级别
            center: initialCenter, // 中心点坐标
            viewMode: '2D' // 使用2D视图, 注意：使用 3D 时，地图轨迹看上去会与地图上的道路有一个固定的偏移量
        });

        // 异步加载控件
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function() {
            const toolbar = new AMap.ToolBar(); // 缩放工具条实例化
            const scale = new AMap.Scale(); // 比例尺实例化
            map.addControl(toolbar); // 添加控件
            map.addControl(scale);
        });

        // eslint-disable-next-line max-lines-per-function
        const createPathSimplifier = () => {
            // 创建组件实例
            const pathSimplifierIns = new PathSimplifier({
                zIndex: 100,
                map: map, // 所属的地图实例
                clickToSelectPath: false,
                autoSetFitView: false,
                getPath: function (pathData, pathIndex) {
                    // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
                    return pathData.path;
                },
                getHoverTitle: function (pathData, pathIndex, pointIndex) {
                    return '';
                },
                renderOptions: {
                    keyPointTolerance: 0,
                    renderAllPointsIfNumberBelow: 10000,
                    getPathStyle: (pathItem, zoom) => {
                        const pathData = pathItem.pathData;
                        return {
                            // 轨迹线的样式
                            pathLineStyle: {
                                strokeStyle: pathData.color,
                                lineWidth: 6,
                                dirArrowStyle: true
                            },
                            pathLineHoverStyle: {
                                strokeStyle: pathData.color
                            },
                            keyPointStyle: {
                                radius: 3,
                                fillStyle: '#fff',
                                strokeStyle: pathData.color
                            }
                        };
                    }
                }
            });

            pathSimplifierIns.setData(EMPTY_ROUTE_DATA);

            return pathSimplifierIns;
        };

        map.on('click', function (e) {
            if (infoWindowExample) {
                infoWindowExample.close();
            }
        });

        const ps = createPathSimplifier();

        const setPsData = data => {
            ps.setData(data);
        };

        controller.bindMap(map, setPsData);
    });

    controller.markSetup();
};

function createWarningMarker(map, { name, point, content, pointData }) {
    const markerId = point.join(',');
    // 创建Marker实例
    const marker = new AMap.Marker({
        // 前景文字
        iconLabel: 'hh',

        // 图标主题
        iconTheme: 'default',

        // 背景图标样式
        iconStyle: 'blue',
        zIndex: 15,

        showPositionPoint: true,
        extData: markerId,
        content,
        position: point,
        // eslint-disable-next-line no-magic-numbers
        offset: [-30, -50],
        map: map
    });

    markersMap.set(markerId, marker);

    const dialogContent = `
        <div class="warning-point-dialog">
            <strong>${name + pointData.warningTypeName}</strong>
            <div>
                ${pointData.locationName}<br />
                预警时间：${pointData.warningTime}<br />
                预警原因：${pointData.warningReason}<br />
                <i class="el-icon-location-outline"></i>
                <span>${pointData.lng},${pointData.lat}</span>
            </div>
        </div>`;
    const infoWindow = new AMap.InfoWindow({
        autoMove: false,
        // eslint-disable-next-line no-magic-numbers
        offset: [0, -35],
        extData: markerId,
        content: dialogContent // 使用默认信息窗体框样式，显示信息内容
    });
    marker.on('mouseover', e => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            if (infoWindowExample === infoWindow) {
                infoWindowExample = null;
            }
            infoWindow.open(map, point);
        }, 300);
    });
    marker.on('mouseout', e => {
        if (infoWindowExample !== infoWindow) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                infoWindow.close(map, point);
            }, 300);
        }
    });
    marker.on('click', e => {
        infoWindow.open(map, point);
        infoWindowExample = infoWindow;
    });
    return marker;
}

function createPlanLineMarker(map, { name, point, content, pointData }) {
    const markerId = point.join(',');
    // 创建Marker实例
    const marker = new AMap.Marker({
        // 前景文字
        iconLabel: 'hh',

        // 图标主题
        iconTheme: 'default',

        // 背景图标样式
        iconStyle: 'blue',

        showPositionPoint: true,
        extData: markerId,
        content,
        position: point,
        // eslint-disable-next-line no-magic-numbers
        offset: [-30, -50],
        map: map
    });

    markersMap.set(markerId, marker);

    const dialogContent = `
        <div class="warning-point-dialog">
            <strong>${name}</strong>
            <div>
                ${pointData.siteAddress}<br />
                <i class="el-icon-location-outline"></i>
                <span>${pointData.siteLng},${pointData.siteLat}</span>
            </div>
        </div>`;
    const infoWindow = new AMap.InfoWindow({
        autoMove: false,
        // eslint-disable-next-line no-magic-numbers
        offset: [0, -35],
        extData: markerId,
        content: dialogContent // 使用默认信息窗体框样式，显示信息内容
    });
    marker.on('mouseover', e => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            if (infoWindowExample === infoWindow) {
                infoWindowExample = null;
            }
            infoWindow.open(map, point);
        }, 300);
    });
    marker.on('mouseout', e => {
        if (infoWindowExample !== infoWindow) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                infoWindow.close(map, point);
            }, 300);
        }
    });
    marker.on('click', e => {
        infoWindow.open(map, point);
        infoWindowExample = infoWindow;
    });
    return marker;
}

function toLinePoint (pos, type) {
    let gd = {};
    if (type === 'BAIDU') { // BAIDU-百度，AMAP-高德
        gd = bd_decrypt(pos.longitude, pos.latitude);
    } else {
        gd = { lng: pos.longitude, lat: pos.latitude };
    }
    return [gd.lng, gd.lat];
}

export class TraceRouteController {
    constructor() {
        this.bounded = false;

        // 是否已经 setup
        this._isSetup = false;
    }

    markSetup() {
        this._isSetup = true;
    }

    isSetup() {
        return this._isSetup;
    }

    destroy() {
        this.map.remove(this.map.getAllOverlays());
        this.map.destroy();
        this._isSetup = false;
    }

    bindMap(map, setPsData) {
        this.map = map;
        this.setPsData = setPsData;
        this.bounded = true;
    }

    clearCover () {
        markersMap = new Map();
        infoWindowExample = null;
        this.map.remove(this.getAllMarkers());
    }

    setWarningPoint (data) {
        if (!this.bounded) return;

        for (let i = 0; i < data.length; i++) {
            if (data[i].lng && data[i].lat) {
                this.addWarningMarker(
                    {
                        longitude: data[i].lng,
                        latitude: data[i].lat,
                        ...data[i]
                    },
                    warningPointContent(i + 1),
                    `第${i + 1}次预警：`
                );
            }
        }
        this.map.setFitView();
    }

    setPlanLinePoint (data) {
        if (!this.bounded) return;

        for (let i = 0; i < data.length; i++) {
            if (data[i].siteLng && data[i].siteLat) {
                this.addPlanLineMarker(
                    {
                        longitude: data[i].siteLng,
                        latitude: data[i].siteLat,
                        ...data[i]
                    },
                    i === 0 ? sentGoodsPointContent(data[i].pointTitle) : receiverGoodsPointContent(data[i].unloadSequenceAmap),
                    data[i].pointName
                );
            }
        }
        this.map.setFitView();
    }

    addWarningMarker (point, content, name) {
        const markerId = toLinePoint(point).join(',');

        if (markersMap.has(markerId)) return;

        createWarningMarker(this.map, {
            name,
            content,
            point: toLinePoint(point),
            pointData: point
        });
    }

    addPlanLineMarker (point, content, name) {
        const markerId = toLinePoint(point).join(',');

        if (markersMap.has(markerId)) return;

        createPlanLineMarker(this.map, {
            name,
            content,
            point: toLinePoint(point),
            pointData: point
        });
    }

    getAllMarkers() {
        return this.map.getAllOverlays();
    }

    setFitView () {
        this.map.setFitView();
    }

    setRouteData(routeData) {
        const psDatas = [];

        for (const data of routeData.routes) {
            if (data.points && data.points.length) {
                const linePoints = data.points.map(i => toLinePoint(i, data.type));

                psDatas.push({
                    ...data,
                    path: linePoints
                });
            }
        }

        this.setPsData(psDatas.length ? psDatas : EMPTY_ROUTE_DATA);

        this.map.setFitView();
    }
}
